import React from 'react'
import PropTypes from 'prop-types'

import layoutQuery from "../hooks/use-layout-query"

import '../assets/scss/main.scss'

import Header from '../components/header'
import Footer from '../components/footer'

const Layout = ({ children, location, pageContext }) => {
  const data = layoutQuery()

  const childrenWithProps = React.Children.map(children, (child) =>
    React.cloneElement(child)
  )

  React.useEffect(() => {
    document.documentElement.style.setProperty(`--mainPaddingMobile`, pageContext?.header === 'white' ? '0px' : '60px');
    document.documentElement.style.setProperty(`--mainPaddingDesktop`, pageContext?.header === 'white' ? '0px' : '90px');
    document.documentElement.style.setProperty(`--headerColour`, pageContext?.header === 'black' ? '#1A1A1A' : '#FFFFFF');
    document.documentElement.style.setProperty(`--headerRolloverColour`, pageContext?.header === 'black' ? '#5B171C' : '#D1D1D1');
    document.documentElement.style.setProperty(`--headerBgColour`, pageContext?.header === 'black' ? '#FFFFFF' : 'transparent');
  }, [pageContext])

  return (
    <>
      <Header location={location} data={data} pageContext={pageContext} />
      <main>{childrenWithProps}</main>
      <Footer data={data} />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
